import * as yup from "yup";
const nameRegExp = /^[A-Za-z]+$/; // Regular expression to allow only letters
const phoneRegExp = /^(01[0,1,2,5])\d{8}$/;
const nameSpaceRegExp = /^[a-zA-Z ]+$/; // Regular expression to allow only letters and spaces
const arabicEnglishRegExp = /^[a-zA-Z\u0600-\u06FF ]*$/;
const arabicEnglishNumbersRegExp = /^[a-zA-Z\u0600-\u06FF0-9 ]*$/;
export const EnSchema = yup.object().shape({
  
  company_name: yup
    .string()
    .min(3, "At least 3 characters long")
    .trim()
    .matches(arabicEnglishNumbersRegExp, "Name is invalid")
    .required("Required"),
  specialist_name: yup
    .string()
    .min(3, "At least 3 characters long")
    .trim()
    .matches(arabicEnglishNumbersRegExp, "Name is invalid")
    .required("Required"),
  phoneNumber: yup
    .string()
    .matches(
      phoneRegExp,
      "Phone number must start with (010/011/012/015) and at least 11 digits"
    )
    .required("Required"),
  email: yup.string().email("Please enter a valid email").required("Required"),
  categories: yup.string().required("Required"),
  url: yup
    .string()
    .min(3, "At least 3 characters long")
    .trim()
    .required("Required"),
  address: yup
    .string()
    .min(3, "At least 3 characters long")
    .trim()
    .required("Required"),
  governorate: yup
    .string()
    .min(3, "At least 3 characters long")
    .required("Required"),
  branch_number: yup
    .string()
    .trim()
    // .min(3, "At least 3 characters long")
    .required("Required"),
  POS: yup.string().required("Required"),
  eCommerce: yup.string().oneOf(["yes", "no"]).required("Required"),
  commercialTax: yup.string().oneOf(["yes", "no"]).required("Required"),
});
export const initialValues = {
  company_name: "",
  specialist_name: "",
  phoneNumber: "",
  email: "",
  categories: "",
  url: "",
  address: "",
  governorate: "",
  branch_number: "",
  POS: "",
  eCommerce: "", // yes/no
  commercialTax: "", // yes/no
};
